var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnalisys(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 26,
    viewBox: "0 0 24 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0C11.6022 0 11.2206 0.158036 10.9393 0.43934C10.658 0.720645 10.5 1.10218 10.5 1.5V24C10.5 24.3978 10.658 24.7794 10.9393 25.0607C11.2206 25.342 11.6022 25.5 12 25.5C12.3978 25.5 12.7794 25.342 13.0607 25.0607C13.342 24.7794 13.5 24.3978 13.5 24V1.5C13.5 1.10218 13.342 0.720645 13.0607 0.43934C12.7794 0.158036 12.3978 0 12 0ZM22.5 12C22.1022 12 21.7206 12.158 21.4393 12.4393C21.158 12.7206 21 13.1022 21 13.5V24C21 24.3978 21.158 24.7794 21.4393 25.0607C21.7206 25.342 22.1022 25.5 22.5 25.5C22.8978 25.5 23.2794 25.342 23.5607 25.0607C23.842 24.7794 24 24.3978 24 24V13.5C24 13.1022 23.842 12.7206 23.5607 12.4393C23.2794 12.158 22.8978 12 22.5 12ZM1.5 6C1.10218 6 0.720645 6.15804 0.43934 6.43934C0.158036 6.72064 0 7.10217 0 7.5V24C0 24.3978 0.158036 24.7794 0.43934 25.0607C0.720645 25.342 1.10218 25.5 1.5 25.5C1.89783 25.5 2.27936 25.342 2.56066 25.0607C2.84196 24.7794 3 24.3978 3 24V7.5C3 7.10217 2.84196 6.72064 2.56066 6.43934C2.27936 6.15804 1.89783 6 1.5 6Z",
    fill: "#212837"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalisys);
export default __webpack_public_path__ + "static/media/analisys.75bca9138be7a8b1b4c40fb9b1ebe4f2.svg";
export { ForwardRef as ReactComponent };